import { useMemo } from "react"
import { useVenue } from "../../../useVenue"
import { PageConfig } from "services/venue"

export const useGetPageConfig = (key: string): PageConfig => {
  const { pageConfig: allPageConfig } = useVenue()
  const pageConfig = useMemo(() => {
    return allPageConfig?.[key] || {}
  }, [key, allPageConfig])
  return pageConfig
}
